import { ApolloClient, createHttpLink, from, InMemoryCache } from '@apollo/client';

import setAuthorizationHeader from './setAuthorizationHeader';

type TAccessMethod = () => Promise<string>;
type ApiClientProps = {
  uri: string;
  getAccessTokenSilently: TAccessMethod;
};

export function createPlatformApiClient({
  uri,
  getAccessTokenSilently,
}: ApiClientProps): ApolloClient<Record<string, unknown>> {
  return new ApolloClient({
    cache: new InMemoryCache({}),
    link: from([setAuthorizationHeader(getAccessTokenSilently), createHttpLink({ uri })]),
  });
}

type AuthenticationClientProps = {
  apiHost: string;
  getAccessTokenSilently: TAccessMethod;
};

export function createAuthenticationApiClient({
  apiHost,
  getAccessTokenSilently,
}: AuthenticationClientProps): ApolloClient<Record<string, unknown>> {
  return new ApolloClient({
    cache: new InMemoryCache({}),
    link: from([
      setAuthorizationHeader(getAccessTokenSilently),
      createHttpLink({ uri: `${apiHost}/wp/authentication/graphql` }),
    ]),
  });
}

type AdminClientProps = {
  apiHost: string;
  getAccessTokenSilently: TAccessMethod;
};
export function createAdministratorApiClient({
  apiHost,
  getAccessTokenSilently,
}: AdminClientProps): ApolloClient<Record<string, unknown>> {
  return new ApolloClient({
    cache: new InMemoryCache({}),
    link: from([
      setAuthorizationHeader(getAccessTokenSilently),
      createHttpLink({ uri: `${apiHost}/wp/admin/graphql` }),
    ]),
  });
}
